(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[95619],{

/***/ 73367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeatureList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35533);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39717);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);







function FeatureList({ featureList , mainTitle , mainDescription , colors , classes  }) {
    const outerSectionStyle = {
        "--bg": `${colors?.bgColor ?? "transparent"}`,
        "--iconColor": `${colors?.iconColor ?? "gray"}`
    };
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: outerSectionStyle,
        className: `mt-10 lg:mt-16 ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().mainSection)} `,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classes?.mainSectionClasses ?? "",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        color: colors?.mainTitleColor ?? "black"
                    },
                    className: classes?.mainTitleClasses ?? "text-center text-xl lg:text-2xl mb-14",
                    children: mainTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    style: {
                        color: colors?.mainDescriptionColor ?? "black"
                    },
                    className: classes?.mainDescriptionClasses ?? "",
                    children: mainDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes?.innerSectionClasses ?? "lg:flex flex-wrap justify-center",
                    children: featureList?.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classes?.oneBoxClasses ? `${classes?.oneBoxClasses} ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""}` : `text-center mb-12 lg:mb-20 w-full lg:w-1/3   ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""} `,
                            children: [
                                item.path ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classes?.iconClasses ?? "relative mb-14 w-[190px] h-[190px]  mx-auto",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: item.path,
                                        layout: "fill",
                                        alt: item.title
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: classes?.iconClasses ?? "children:w-12 children:h-12 children:mx-auto ",
                                    children: item.icon
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    style: {
                                        color: colors?.titleColor ?? "black"
                                    },
                                    className: classes?.titleClasses ?? "font-medium text-lg lg:text-xl mt-6",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        color: colors?.descriptionColor ?? "black"
                                    },
                                    className: classes?.descriptionClasses ?? "font-light text-sm text-center w-4/5 mx-auto mt-2",
                                    children: item.description
                                }),
                                item.tool && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: `/tools/${item.tool}?${(0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start")}`,
                                    className: classes?.toolClasses ? `${classes?.toolClasses} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}` : `mt-4 flex gap-2 items-center md:mt-auto ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}`,
                                    style: {
                                        color: colors?.toolColor ?? "black"
                                    },
                                    children: [
                                        "Details",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            className: "transform rotate-180",
                                            fill: colors?.chevronColor
                                        })
                                    ]
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 95619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Advantages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/steelbuildingestimates/icons/Flame.tsx


function Flame() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "64",
        height: "80",
        fill: "none",
        viewBox: "0 0 64 80",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M28.7 8.4c6.2 5.8 9.1 13.3 9.2 23.7 0 2.8 2 5.2 4.7 5.6.3.1.6.1.9.1 3.1 0 5.5-2.4 5.6-5.5v-.8c0-.4 0-1.3.099-2.3 0-.9 1.1-1.3 1.7-.7 5.3 5.8 8.4 13.3 8.4 20.9 0 6.499-3.1 13.2-8.4 18.299-5.4 5.2-12.4 8.1-19.3 8.1s-13.9-3-19.3-8.1c-5.3-5.1-8.4-11.8-8.4-18.3 0-10.3 6.3-17.5 11.8-23.7 6.3-7.1 9.6-12.9 10.2-17.6.1-.8 1-1.1 1.6-.6l1.2.901zM22.6 0c-.7 0-1.3.3-1.7.9-.4.7.2 2.2.9 4.1 1.4 4.3-2.9 11.2-9 18.1C7.1 29.6 0 37.6 0 49.5 0 65.5 15.1 80 31.7 80s31.7-14.5 31.7-30.5c0-10.1-4.8-20.1-12.8-26.8l-1-.8c-.5-.4-1-.6-1.6-.6-.9 0-1.8.5-2.2 1.4-.3.7-.6 7.7-.6 8.9v.7c0 .9-.7 1.6-1.6 1.6h-.3c-.8-.1-1.4-.9-1.4-1.7-.1-11.999-3.7-20.4-10.5-26.7C28.3 2.6 24.8 0 22.6 0z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M31.7 46.9l6.3 7.5.2.2c1.7 1.7 2.599 3.999 2.599 6.4 0 5-4.1 9.1-9.1 9.1s-9.1-4.1-9.1-9.1c0-2.4.9-4.7 2.6-6.4l.2-.2 6.3-7.5m0-4.6c-.8 0-1.6.3-2.2 1l-7.2 8.6c-2.3 2.4-3.8 5.6-3.8 9.2 0 7.2 5.9 13.1 13.1 13.1 7.2 0 13.1-5.9 13.1-13.1 0-3.6-1.4-6.8-3.8-9.2l-7.2-8.6c-.4-.7-1.2-1-2-1z"
            })
        ]
    });
}
/* harmony default export */ var icons_Flame = (Flame);

;// CONCATENATED MODULE: ./src/components/steelbuildingestimates/icons/Lifespan.tsx


function Lifespan() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "80",
        height: "80",
        fill: "none",
        viewBox: "0 0 80 80",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M40 0C17.95 0 0 17.95 0 40s17.95 40 40 40 40-17.95 40-40S62.05 0 40 0zm0 76.662C19.788 76.662 3.338 60.212 3.338 40S19.788 3.338 40 3.338 76.662 19.788 76.662 40 60.212 76.662 40 76.662z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M73.2 38.336h-4.826c-.874-14.85-13.187-26.662-28.25-26.662V15c13.225 0 24.05 10.325 24.912 23.337h-4.65c-1.812.125-1.95 1.975-1.3 2.7l6.413 8.088c.312.4 1.575 1.212 2.613 0l6.412-8.088c.55-.575.562-2.613-1.325-2.7zM66.8 45.4l-2.963-3.738h5.925L66.8 45.4zM38.45 64.95l-.2 3.324c.575.038 1.162.05 1.75.05.6 0 1.212-.012 1.8-.05l-.212-3.325a26.4 26.4 0 01-3.138 0zM31.276 66.962c1.125.362 2.287.662 3.45.874l.612-3.275a23.015 23.015 0 01-3.037-.775l-1.025 3.176zM44.713 64.562l.625 3.275a29.698 29.698 0 003.45-.888l-1.038-3.174a25.23 25.23 0 01-3.037.787zM24.85 63.936c1 .637 2.05 1.212 3.112 1.712l1.413-3.012c-.95-.438-1.875-.95-2.75-1.513l-1.775 2.813zM50.663 62.623l1.425 3.013a30.215 30.215 0 003.112-1.713l-1.787-2.812a29.376 29.376 0 01-2.75 1.512zM19.375 59.425a26.76 26.76 0 002.6 2.438l2.125-2.576a23.243 23.243 0 01-2.287-2.15l-2.438 2.288zM55.937 59.261l2.125 2.563a27.944 27.944 0 002.587-2.438L58.224 57.1a25.067 25.067 0 01-2.287 2.162zM18.113 52.074L15.2 53.686a28.968 28.968 0 001.913 3l2.687-1.962a22.691 22.691 0 01-1.687-2.65zM60.237 54.687l2.7 1.962c.7-.962 1.338-1.962 1.912-3l-2.925-1.612c-.512.913-1.075 1.8-1.687 2.65zM15.788 46.262l-3.225.837c.3 1.138.662 2.275 1.1 3.387l3.1-1.237a25.245 25.245 0 01-.975-2.987zM15 40.05l-3.338.012c0 1.188.075 2.375.225 3.55l3.313-.425a26.292 26.292 0 01-.2-3.137zM15.763 33.837l-3.225-.825a27.35 27.35 0 00-.65 3.5l3.312.412c.113-1.05.313-2.087.563-3.087zM18.063 28l-2.925-1.6a28.07 28.07 0 00-1.513 3.225l3.1 1.226c.388-.976.838-1.926 1.338-2.85zM21.738 22.937l-2.437-2.275a26.456 26.456 0 00-2.263 2.75l2.7 1.95a23.359 23.359 0 012-2.425zM26.55 18.925l-1.8-2.812c-1 .638-1.963 1.338-2.875 2.1l2.137 2.563c.8-.663 1.662-1.288 2.538-1.85zM32.2 16.237l-1.038-3.162a26.009 26.009 0 00-3.3 1.324l1.425 3.013a23.24 23.24 0 012.913-1.175zM38.35 15.05l-.212-3.325a27.394 27.394 0 00-3.525.45l.638 3.274c1.011-.2 2.061-.324 3.099-.4zM41.663 35.312v-13.65a1.662 1.662 0 10-3.325 0v13.637a4.97 4.97 0 00-3.025 3.025H25.001a1.662 1.662 0 100 3.325h10.313c.687 1.95 2.512 3.35 4.687 3.35 2.762 0 5-2.238 5-5 0-2.175-1.4-4-3.338-4.688zm-1.662 6.35a1.662 1.662 0 111.663-1.663c0 .913-.739 1.662-1.663 1.662z"
            })
        ]
    });
}
/* harmony default export */ var icons_Lifespan = (Lifespan);

;// CONCATENATED MODULE: ./src/components/steelbuildingestimates/icons/Quality.tsx


function Quality() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "80",
        height: "80",
        fill: "none",
        viewBox: "0 0 80 80",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M64.15 57.843l2.904 1.66.083-.167c4.066-5.642 6.224-12.365 6.224-19.419.083-9.045-3.32-17.51-9.627-23.817C57.427 9.71 49.045 6.14 40.083 6.14c-18.507 0-33.61 15.104-33.61 33.61 0 18.507 15.02 33.527 33.527 33.527 3.236 0 6.306-.415 9.211-1.327l.166-.083-.664-3.32-.248.083c-2.822.83-5.727 1.328-8.631 1.328-16.598 0-30.125-13.527-30.125-30.124C9.71 23.237 23.237 9.71 39.834 9.71s30.125 13.527 30.125 30.125c0 6.39-1.992 12.53-5.81 17.842v.166z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M68.382 11.785C60.829 4.149 50.705 0 40.082 0c-3.734 0-7.303.498-10.704 1.493l-.167.083.582 3.07.248-.082c3.32-.913 6.722-1.41 10.042-1.41 20.332 0 36.93 16.514 36.93 36.929 0 20.416-16.598 36.847-36.93 36.847-20.415-.083-36.93-16.681-36.93-37.013 0-7.718 2.324-15.02 6.806-21.328l.165-.166-2.738-1.577-.083.166C2.49 23.734 0 31.702 0 40.082 0 62.076 17.925 80 39.917 80c22.075 0 40.084-17.925 40.084-39.917 0-10.705-4.067-20.747-11.619-28.3v.002z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M28.381 36.1l-4.315 4.316 11.867 11.867L55.85 32.364l-4.316-4.315-15.601 15.602L28.38 36.1z"
            })
        ]
    });
}
/* harmony default export */ var icons_Quality = (Quality);

;// CONCATENATED MODULE: ./src/components/steelbuildingestimates/icons/Recycle.tsx


function Recycle() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "85",
        height: "80",
        fill: "none",
        viewBox: "0 0 85 80",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#fff",
            d: "M83.33 47.241c-4.126-6.829-12.355-20.498-12.355-20.498l-16.97 10.236 11.191 18.552h-7.481v-5.016L45.02 64.945 57.714 80v-4.89L68 75.133s3.857.247 5.577-3.465a3074.963 3074.963 0 008.98-15.637c1.078-1.897 3.256-4.675.775-8.79h-.001zM71.053 69.433c-1.2 2.434-3.296 2.414-3.296 2.414H54.83l-5.543-6.879 5.05-6.304H77.25c0 .001-3.862 6.717-6.197 10.77zm3.302-13.95l-5.317.028L58.535 38.1l11.313-6.822c1.71 2.855 8.43 13.993 10.453 17.35 3.063 5.075-2.691 6.812-5.947 6.857zm-55.164.04l3.825-6.43 4.33 2.606-5.815-18.317-19.444 3.11 4.189 2.521-5.323 8.802s-2.202 3.178.091 6.565A3252.547 3252.547 0 009.81 70.136c1.067 1.902 2.324 5.201 7.13 5.197 7.979-.012 23.935-.014 23.935-.014l-.017-19.818-21.667.021zm-8.903 8.711S6.525 57.46 4.257 53.37c-1.466-2.283-.368-4.068-.368-4.068l6.668-11.075 8.75-1.2 2.798 7.576-11.818 19.631zm7.028 7.791c-5.929.006-4.45-5.819-2.81-8.632l2.72-4.568 20.334-.018.012 13.208c-3.33-.004-16.337.007-20.257.01zM60.5 28.117l6.69-18.52-4.235 2.446-5.124-8.918S56.116-.34 52.044.027c-4.433 0-11.773.007-18.032.045-2.182.014-5.678-.481-8 3.723A23626.642 23626.642 0 0114.44 24.748l17.351 9.575L42.26 15.355l3.777 6.46-4.378 2.528 18.842 3.774zM30.497 29.84l-11.565-6.384c1.617-2.91 7.902-14.298 9.796-17.729 2.864-5.19 7.245-1.077 8.912 1.72l2.682 4.59-9.825 17.803zm8.449-26.491s7.748-.015 12.424-.018c2.708-.178 3.739 1.646 3.739 1.646l6.465 11.195-3.185 8.239-7.983-1.22L38.946 3.35z"
        })
    });
}
/* harmony default export */ var icons_Recycle = (Recycle);

;// CONCATENATED MODULE: ./src/components/steelbuildingestimates/advantages/advantages.tsx





const advantages = [
    {
        title: "Product Quality",
        description: "Steel is a manufactured commodity and product quality is assured. As a material, steel is flawless and free of defect.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Quality, {})
    },
    {
        title: "Recyclable",
        description: "Steel is the most recycled material on earth. making steel construction the ideal choice for the environment. It's the Green solution.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Recycle, {})
    },
    {
        title: "Non-Flammable",
        description: "Steel doesn't catch fire. It can contain a fire, it can keep a fire out, and keep it from spreading. Steel is recognized to have an A-Fire Rating.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Flame, {})
    },
    {
        title: "Long Lifespan",
        description: "Steel does not decompose. It remains sturdy and durable. Walls remain straight, floors are flat. Steel requires little to no maintenance.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Lifespan, {})
    }, 
];
/* harmony default export */ var advantages_advantages = (advantages);

// EXTERNAL MODULE: ./src/components/shared/featureList/index.tsx
var featureList = __webpack_require__(73367);
// EXTERNAL MODULE: ./src/styles/variables/steelbuildingestimatesVariables.module.scss
var steelbuildingestimatesVariables_module = __webpack_require__(23771);
var steelbuildingestimatesVariables_module_default = /*#__PURE__*/__webpack_require__.n(steelbuildingestimatesVariables_module);
;// CONCATENATED MODULE: ./src/components/steelbuildingestimates/advantages/index.tsx




function Advantages() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(featureList/* default */.Z, {
        featureList: advantages_advantages,
        mainTitle: "Pre-Engineered Steel Building Solutions - The Advantages",
        mainDescription: "The Benefits of Steel as a Material Are Well Known in the Construction Industry, They Include:",
        colors: {
            bgColor: (steelbuildingestimatesVariables_module_default()).blue,
            mainTitleColor: "white",
            mainDescriptionColor: "white",
            titleColor: "white",
            descriptionColor: "white"
        },
        classes: {
            mainSectionClasses: "flex flex-col mx-auto px-4vw lg:px-4 py-10 md:py-36 -mt-16",
            mainTitleClasses: "font-bold capitalize mb-4  mx-auto md:mb-6 text-2xl text-center  md:text-4xl ",
            mainDescriptionClasses: "capitalize mb-12  mx-auto md:mb-20 text-lg text-center  md:text-2xl ",
            innerSectionClasses: "grid grid-cols md:grid-cols-2 lg:grid-cols-4 text-center gap-16",
            oneBoxClasses: "flex flex-col justify-center items-center",
            iconClasses: "mx-auto mb-8",
            titleClasses: "text-xl md:text-2xl mb-2 font-semibold",
            descriptionClasses: "text-sm leading-5"
        }
    });
}


/***/ }),

/***/ 39717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Chevron; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Chevron({ className , fill  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "8",
        height: "12",
        viewBox: "0 0 8 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.4 1.4L6 0L0 6L6 12L7.4 10.6L2.8 6L7.4 1.4Z",
            fill: fill ?? "black"
        })
    });
}


/***/ }),

/***/ 35533:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","item":"styles_item__j6_jF","mainSection":"styles_mainSection__2nFt8","link":"styles_link___4DQd"};

/***/ }),

/***/ 23771:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"orange":"#faa931","blue":"#0d4085"};

/***/ })

}]);